import { useEffect, useRef } from "react";

import { useLoading } from "../contexts/LoadingContext";

const GlobalFullPageLoader = ({ id, message = "" }) => {
  const { showLoading, hideLoading } = useLoading();
  const fallbackIdRef = useRef(
    `global-loader-${Math.random().toString(36).slice(2)}`
  );
  const resolvedId = id || fallbackIdRef.current;

  useEffect(() => {
    showLoading(resolvedId, message);
    return () => {
      hideLoading(resolvedId);
    };
  }, [hideLoading, message, resolvedId, showLoading]);

  return null;
};

export default GlobalFullPageLoader;
